
<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card">
    <div class="card-header">
      <div class="float-end fit-content h-100 d-flex flex-column align-items-end mt-2 gap-2">
      </div>
      <h5 class="card-title">{{ 'settings' | translate }}</h5>
      <h6 class="card-subtitle text-muted">{{ 'ancDeviceCfgDesc' | translate }}</h6>
    </div>

    <div class="card-body">
      <form>
        <div class="row gx-4 gy-3">
          <!-- Columna 1: Modelo → Contraste -->
          <div class="col-12 col-lg-6 d-flex">
            <div class="px-3 d-flex flex-column justify-content-lg-center h-100 w-100">
            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-sm-right">{{ 'modelo' | translate }}</label>
              <div class="col-sm-8">
                <input [disabled]="true" type="text" class="form-control"
                  [placeholder]="'modelo' | translate" name="Model" [(ngModel)]="modelData.description">
              </div>
            </div>

            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-sm-right">{{ 'language' | translate }}</label>
              <div class="col-sm-8">
                <select class="form-select" name="language" [(ngModel)]="dataCfgDevice.language"
                    (change)="changesMadeDevice=_deviceService.checkChangesSettings(originalDataDevice,dataCfgDevice)">
                  <option *ngFor="let item of modelData?.languages; let i = index" [ngValue]="i">{{ item }}</option>
                </select>
              </div>
            </div>

            <ng-container *ngIf="isAncFamily">
              <div class="form-group row">
                <label class="col-form-label col-sm-4 text-sm-right">{{ 'country' | translate }}</label>
                <div class="col-sm-8">
                  <select class="form-select" name="country" [(ngModel)]="dataCfgDevice.country"
                    (change)="changesMadeDevice=_deviceService.checkChangesSettings(originalDataDevice,dataCfgDevice)">
                    <option *ngFor="let item of modelData?.countries; let i = index" [ngValue]="i">{{ item.country }}</option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-form-label col-sm-4 text-sm-right">{{ 'city' | translate }}</label>
                <div class="col-sm-8">
                  <select class="form-select" name="city" [(ngModel)]="dataCfgDevice.city" [disabled]="dataCfgDevice.country === null || dataCfgDevice.country === undefined"
                    (change)="changesMadeDevice=_deviceService.checkChangesSettings(originalDataDevice,dataCfgDevice)">
                    <option *ngFor="let z of modelData?.countries?.[dataCfgDevice.country]?.zone; let i = index" [ngValue]="i">{{ z.city }}</option>
                  </select>
                </div>
              </div>
            </ng-container>

            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-sm-right">{{ 'screenBrightness' | translate }}</label>
              <div class="col-sm-8">
                <div class="d-flex align-items-center gap-3">
                  <input [disabled]="false" type="range" class="form-range flex-fill"
                    min="0" max="4" step="1" name="Contrast" [(ngModel)]="dataCfgDevice.contrast"
                    (input)="changesMadeDevice=_deviceService.checkChangesSettings(originalDataDevice,dataCfgDevice)">
                  <span class="badge bg-primary" style="min-width: 40px;">{{dataCfgDevice.contrast}}</span>
                </div>
              </div>
            </div>
            </div>
          </div>

          <!-- Columna 2: resto -->
          <div class="col-12 col-lg-6">
            <div class="px-3">
            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-sm-right">{{ 'output1Hours' | translate }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch"
                    (change)="changePermanentOutput(1, $event.target.checked)"
                    [checked]="dataCfgDevice.permanent === 1 || dataCfgDevice.permanent === 3"
                    name="permanentOut1" >
                  <label class="form-check-label">{{ 'tourDevicePermanentTitle' | translate }}</label>
                </div>
              </div>
            </div>

            <div class="form-group row" *ngIf="outputCount > 1">
              <label class="col-form-label col-sm-4 text-sm-right">{{ 'output2Hours' | translate }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch"
                    (change)="changePermanentOutput(2, $event.target.checked)"
                    [checked]="dataCfgDevice.permanent === 2 || dataCfgDevice.permanent === 3"
                    name="permanentOut2">
                  <label class="form-check-label">{{ 'tourDevicePermanentTitle' | translate }}</label>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-sm-right">{{ 'pinLock' | translate }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch"
                    name="pwdEnDis" [(ngModel)]="dataCfgDevice.pwdEnDis"
                    (ngModelChange)="changesMadeDevice=_deviceService.checkChangesSettings(originalDataDevice,dataCfgDevice)">
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-sm-right">{{ 'timeFormat' | translate }}</label>
              <div class="col-sm-8">
                <select class="form-select" name="mode1224" [(ngModel)]="dataCfgCalendar.mode1224"
                  (change)="changesMadeCalendar=_deviceService.checkChangesSettings(originalDataCalendar,dataCfgCalendar)">
                  <option [ngValue]="0">{{ 'format24h' | translate }}</option>
                  <option [ngValue]="1">{{ 'format12h' | translate }}</option>
                </select>
              </div>
            </div>

            <ng-container *ngIf="isAncFamily">
              <div class="form-group row">
                <label class="col-form-label col-sm-4 text-sm-right">{{ 'correctionSunrise' | translate }}</label>
                <div class="col-sm-8 d-flex align-items-center gap-2">
                  <select class="form-select w-auto" [(ngModel)]="signoCorrSunrise" name="sunriseSign" (change)="changesMadeCalendar = true" >
                    <option [ngValue]="'+'">+</option>
                    <option [ngValue]="'-'">-</option>
                  </select>
                  <input class="form-control flex-fill" type="time" id="sunrise" [(ngModel)]="sunrise" name="sunrise" (change)="changesMadeCalendar = true  ">
                </div>
              </div>

              <div class="form-group row">
                <label class="col-form-label col-sm-4 text-sm-right">{{ 'correctionSunset' | translate }}</label>
                <div class="col-sm-8 d-flex align-items-center gap-2">
                  <select class="form-select w-auto" [(ngModel)]="signoCorrSunset" name="sunsetSign" (change)="changesMadeCalendar = true" >
                    <option [ngValue]="'+'">+</option>
                    <option [ngValue]="'-'">-</option>
                  </select>
                  <input class="form-control flex-fill" type="time" id="sunset" [(ngModel)]="sunset" name="sunset"  (change)="changesMadeCalendar = true ">
                </div>
              </div>

              <div class="form-group row">
                <label class="col-form-label col-sm-4 text-sm-right">{{ 'sunTimesYearlyTitle' | translate }}</label>
                <div class="col-sm-8 d-flex align-items-center">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    (click)="openYearlySunTimes()"
                  >
                    <i class="fas fa-chart-line me-1"></i>
                    {{ 'sunTimesYearlyButton' | translate }}
                  </button>
                </div>
              </div>
            </ng-container>
            </div>
          </div>
        </div>


        <div class="form-group row ">
          <div class="col-12 d-flex justify-content-center gap-2">
            <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!changesMadeDevice && !changesMadeCalendar">{{ 'overwrite' | translate }}</button>
            <button type="button" class="btn btn-light" [disabled]="!changesMadeDevice && !changesMadeCalendar" (click)="restore()">{{ 'restore' | translate }}</button>
          </div>
        </div>

        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
          <div class="alert-message">
            {{ error }}
          </div>
        </div>
        <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
          <div class="alert-message">
            {{ 'updatedSuccesfully' | translate }}
          </div>
        </div>

      </form>
    </div>
  </div>
</div>
